var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 48,
    viewBox: "0 0 60 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.9681 1.94581C55.7751 -0.477193 52.0321 -0.662193 49.6091 1.53081L25.4811 34.1868L9.99114 23.4298C7.62014 21.1798 3.87414 21.2778 1.62514 23.6478C-0.623862 26.0178 -0.526861 29.7628 1.84314 32.0128L21.0511 46.2958C22.1961 47.3838 23.6601 47.9228 25.1231 47.9228C25.9451 47.9228 26.7661 47.7468 27.5291 47.4068C28.4141 47.1748 29.2581 46.7328 29.9841 46.0748L57.5521 10.3038C59.9761 8.11081 60.1611 4.36881 57.9681 1.94581Z",
    fill: "#F1FA29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.e230ed7564975dd54b9bbedca0c71356.svg";
export { ForwardRef as ReactComponent };